import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2afd06df"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "degraded-service-banner py-2 px-3 text-center f-12 fw-medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasMessages)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "banner-fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("span", { key: _ctx.currentIndex }, _toDisplayString(_ctx.currentMessage), 1))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}